(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.btnHeaderMobile = btnHeaderMobile;
function btnHeaderMobile() {
  var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
  if (headerBtnMobile) {
    var toggleHeader = function toggleHeader(event) {
      event.preventDefault();
      headerNav.classList.toggle("active");
      headerBtnMobile.classList.toggle("active");
      headerOverlay.classList.toggle("active");
    };
    var headerNav = document.querySelector('[data-header="nav"] ul');
    var headerOverlay = document.querySelector('[data-header="overlay"]');
    headerBtnMobile.addEventListener("click", toggleHeader);
    headerOverlay.addEventListener("click", toggleHeader);
  }
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerInternLinks = headerInternLinks;
function headerInternLinks() {
  var internLinks = document.querySelectorAll("[data-header=\"nav\"] ul li a[href^=\"#\"]");
  var isMax991px = window.matchMedia("(max-width: 991px)").matches;
  if (isMax991px && internLinks.length) {
    var scrollToSection = function scrollToSection() {
      var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
      headerBtnMobile.click();
    };
    internLinks.forEach(function (link) {
      link.addEventListener("click", scrollToSection);
    });
  }
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerLinkActiveOnScroll = headerLinkActiveOnScroll;
function headerLinkActiveOnScroll() {
  var sections = document.querySelectorAll("[data-section]");
  var linksIntern = document.querySelectorAll('[data-header="nav"] .intern-link');
  if (sections.length) {
    var handleScroll = function handleScroll() {
      sections.forEach(function (section) {
        var sectionTarget = section[0] ? section[0] : section;
        if (sectionTarget) {
          var sectionTop = sectionTarget.getBoundingClientRect().top;
          var isTopSectionVisible = sectionTop - scroll40Percentage < 0;
          var dataSection = sectionTarget.dataset.section;
          if (isTopSectionVisible && !sectionTarget.classList.contains("active")) {
            sectionTarget.classList.add("active");
            if (dataSection) {
              var linkTarget = document.querySelector("[data-header=\"nav\"] .link-".concat(dataSection));
              linksIntern.forEach(function (link) {
                if (link === linkTarget) {
                  link.classList.add("active");
                } else if (link.classList.contains("active")) {
                  link.classList.remove("active");
                }
              });
            } else {
              linksIntern.forEach(function (link) {
                return link.classList.remove("active");
              });
            }
          } else if (!isTopSectionVisible && sectionTarget.classList.contains("active")) {
            sectionTarget.classList.remove("active");
            var sectionsUpdated = document.querySelectorAll("[data-section]");
            var sectionsActive = Array.from(sectionsUpdated).filter(function (section) {
              if (section.classList.contains("active")) return section;
            });
            var lastSectionActive = sectionsActive[sectionsActive.length - 1];
            var lastSectionActiveData = lastSectionActive.dataset.section;
            if (lastSectionActiveData) {
              var _linkTarget = document.querySelector(".link-".concat(lastSectionActiveData));
              linksIntern.forEach(function (link) {
                if (link === _linkTarget) {
                  link.classList.add("active");
                } else if (link.classList.contains("active")) {
                  link.classList.remove("active");
                }
              });
            } else {
              linksIntern.forEach(function (link) {
                return link.classList.remove("active");
              });
            }
          }
        }
      });
    };
    var scroll40Percentage = window.innerHeight * 0.4;
    handleScroll();
    window.addEventListener("scroll", handleScroll);
  }
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portfolioSlider = portfolioSlider;
function portfolioSlider() {
  var portfolioSliderSwiper = new Swiper('[data-portfolio="slider"]', {
    centerInsufficientSlides: true,
    slidesPerView: 1.2,
    speed: 400,
    spaceBetween: 16,
    navigation: {
      prevEl: '[data-portfolio="slider-prev"]',
      nextEl: '[data-portfolio="slider-next"]'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32
      }
    }
  });
}

},{}],5:[function(require,module,exports){
"use strict";

var _headerBtnMobile = require("./modules/headerBtnMobile.js");
var _headerInternLinks = require("./modules/headerInternLinks.js");
var _headerLinkActiveOnScroll = require("./modules/headerLinkActiveOnScroll.js");
var _portfolioSlider = require("./modules/portfolioSlider.js");
(0, _headerLinkActiveOnScroll.headerLinkActiveOnScroll)();
(0, _headerInternLinks.headerInternLinks)();
(0, _portfolioSlider.portfolioSlider)();
(0, _headerBtnMobile.btnHeaderMobile)();
window.scrollTo(0, 0);
window.addEventListener("load", function () {
  // AOS
  var isMax991px = window.matchMedia("(max-width: 991px)").matches;
  if (isMax991px) {
    AOS.init({
      once: true,
      duration: 650,
      offset: 260
    });
  } else {
    AOS.init({
      once: true,
      duration: 650,
      offset: 200
    });
  }
});

},{"./modules/headerBtnMobile.js":1,"./modules/headerInternLinks.js":2,"./modules/headerLinkActiveOnScroll.js":3,"./modules/portfolioSlider.js":4}]},{},[5]);
